import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFUserList = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 22",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.9,16.16c-.75,0-1.57.05-2.45.05-3.23,0-5.78-.21-6.29-1A3.5,3.5,0,0,1,1,13.5c.52-3.4,2.16-3.17,4.34-4.36a1,1,0,0,0,.3-.27,4.13,4.13,0,1,1,3.56,0,1.17,1.17,0,0,0,.29.27c.47.25.91.44,1.32.61a6.51,6.51,0,0,0-.94,6.41ZM21,14.09a5,5,0,0,1-5,4.67h-.32a4.93,4.93,0,0,1-2.5-.89L9.82,20.92,8.21,19.13l3.41-3.06A5,5,0,0,1,16,8.8h.31A5,5,0,0,1,21,14.09ZM19,14a3,3,0,0,0-2.78-3.16H16a3,3,0,0,0-.18,5.95H16A3,3,0,0,0,19,14Z" })
});
export default SvgFUserList;
